<div class="ui-toast-stack" aria-live="polite">
  @for (toast of toasts(); track toast.id) {
    <div
      class="ui-toast"
      [class]="'ui-toast--' + toast.variant"
      [attr.role]="liveRole(toast.variant)"
    >
      <span class="ui-toast__icon" aria-hidden="true">
        <hugeicons-icon [icon]="icon(toast.variant)" [size]="20" [strokeWidth]="2" color="currentColor" />
      </span>

      <div class="ui-toast__body">
        <p class="ui-toast__title">{{ toast.title }}</p>
        @if (toast.message) {
          <p class="ui-toast__message">{{ toast.message }}</p>
        }
      </div>

      <button type="button" class="ui-toast__close" aria-label="Dismiss" (click)="dismiss(toast)">
        <hugeicons-icon [icon]="CloseIcon" [size]="16" [strokeWidth]="2" color="currentColor" />
      </button>

      @if (toast.duration > 0) {
        <!-- Keyed on `run` so a restarted countdown redraws the bar from full. -->
        @for (run of [toast.run]; track run) {
          <span
            class="ui-toast__progress"
            [style.animation-duration.ms]="toast.duration"
            aria-hidden="true"
          ></span>
        }
      }
    </div>
  }
</div>
